module.exports = __webpack_public_path__ + "static/img/case1.79d8f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coorperation/case1.png
// module id = dNWA
// module chunks = 6